import { ReactComponent as IconArrowLeft } from 'assets/icons/ic_arrow_l.svg';
import { ReactComponent as IconArrowRight } from 'assets/icons/ic_arrow_r.svg';

// Import styles
import { ArrowButton } from './styles';

type Props = {
	isPrev: boolean;
	element: '.arrow__next' | '.arrow__prev';
};

export const SliderArrow = ({ element }: Props) => {
	const isPrev = element === '.arrow__prev';
	return <ArrowButton className={element.replace('.', '')}>{isPrev ? <IconArrowLeft /> : <IconArrowRight />}</ArrowButton>;
};
